import { render, staticRenderFns } from "./langDuKeWen.vue?vue&type=template&id=a646adb6&scoped=true&"
import script from "./langDuKeWen.vue?vue&type=script&lang=js&"
export * from "./langDuKeWen.vue?vue&type=script&lang=js&"
import style0 from "./langDuKeWen.vue?vue&type=style&index=0&id=a646adb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a646adb6",
  null
  
)

export default component.exports